export const translationLanguageKey = [
  "en",
  "es",
  "pt",
  "it",
  "fr",
  "de",
  "el",
  "pl",
  "zh"
];
